import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '视频分类',
      links: [
        { label: '电视剧', path: '/category/tv-series' },
        { label: '电影', path: '/category/movies' },
        { label: '动漫', path: '/category/anime' },
        { label: '综艺', path: '/category/variety' },
        { label: '纪录片', path: '/category/documentary' },
      ],
    },
    {
      title: '热门推荐',
      links: [
        { label: '精选推荐', path: '/' },
        { label: '最新更新', path: '/' },
        { label: '排行榜', path: '/' },
        { label: '影视资讯', path: '/' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', path: '/about' },
        { label: '联系方式', path: '/about' },
        { label: '用户口碑', path: '/about' },
      ],
    },
    {
      title: '友情链接',
      links: [
        { label: '香蕉视频', path: 'https://www.xjsp.com', external: true },
        { label: '糖豆视频', path: 'https://www.tdsp.com', external: true },
        { label: '小蓝视频', path: 'https://www.xlsp.com', external: true },
        { label: '蓝莓视频', path: 'https://www.lmsp.com', external: true },
      ],
    },
  ];

  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    {link.external ? (
                      <a
                        href={link.path}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-700/30 max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <span className="text-lg font-bold font-heading text-background-50 whitespace-nowrap">
                密桃视频
              </span>
              <span className="text-xs text-foreground-400">
                — 高清全集在线观看不缓冲
              </span>
            </div>
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} 密桃视频 mitao.com. 本站内容来源于互联网，仅供网友学习交流。
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}